import * as types from "./types.js"
import * as api from "./api.js"


function getNotesRequest() {
    return {
        type: types.GET_NOTES_REQUEST
    }
}

function getNotesReceived(notes) {
    return {
        type: types.GET_NOTES_RECEIVED,
        payload: notes
    }
}

function getNotesError(e) {
    return {
        type: types.GET_NOTES_ERROR,
        payload: e,
        error: true
    }
}

export function getNotes(personid) {
    return dispatch => {
        dispatch(getNotesRequest())
        return api.getNotes(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getNotesError(res.statusText))
            } else {
                return res.json()
                .then(notes => {
                    dispatch(getNotesReceived(notes))
                })
            }
        })
    }
}


function postNoteRequest() {
    return {
        type: types.POST_NOTE_REQUEST
    }
}

/*function postNoteReceived(note) {
    return {
        type: types.POST_NOTE_RECEIVED,
        payload: note
    }
}*/

function postNoteError(e) {
    return {
        type: types.POST_NOTE_ERROR,
        payload: e,
        error: true
    }
}

export function postNote(note) {
    return dispatch => {
        dispatch(postNoteRequest())
        return api.postNote(note)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postNoteError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(getNotes(note.personid))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/notes/actions.js
 **/